import React from 'react';

export default class GratuityInput extends React.Component {
  constructor(props) {
    super(props);
    this.nameRef = React.createRef();
    this.cursor = null;
  }

  render() {
    return (
      <input
        aria-label="Gratuity Input"
        autoFocus
        type="text" inputMode="decimal"
        ref={this.nameRef}
        className={this.props.className}
        value={this.props.value}
        id={this.props.id}
        onChange={e => {
          this.props.onChange(e);
        }}
        onKeyDownCapture={(e) => this.props.onKeyDown(e)}
      />
    );
  }
}
